type PriceValue = number | string | null | undefined;

/**
 * RKB-2716: admin（天神模式）調整過的價格要直接顯示在畫面上，不能只用驚嘆號暗示。
 *
 * 一律用 `||`，不得用 `??`。天神模式寫入端是 `adminBidPrice || null`
 * （見 RtbCampaignWebService.updateCampaignAdminBidPrice），`0` 已經代表「未調整」，
 * 所以 null / undefined / 0 都要退回 baseline。用 `??` 會讓 0 顯示成 NTD 0。
 *
 * baseline 依顯示點而異：合約價格相關的畫面傳 orderPrice，出價上限相關的畫面傳 bidPrice。
 *
 * 所有計價模式一律套用這條規則：
 * 天神模式可以對任何有 bidPrice 的活動設 adminBidPrice，而活動列表與 Dashboard
 * （CampaignBidPriceInfo）本來就不看計價模式，加閘門會讓編輯頁與列表對不起來。
 *
 * 回傳值純粹給 render 用：**不得寫回 formik、不得進入任何 API payload**。
 * 送出 payload 是整個 campaign.basic spread 出去的（見 RtbCampaignManager.wrapCampaignForServer），
 * orderPrice 與 bidPrice 都在裡面，改 formik value 會真的寫進資料庫。
 */
export function getDisplayPrice(
  adminBidPrice: PriceValue,
  baseline: PriceValue
): PriceValue {
  return adminBidPrice || baseline;
}
